<script setup lang="ts">
import { computed } from 'vue'

import { BlockContainer, AdDivider } from '@toni/brand-ui'

import BlockAdvertorialBadge from '../page-blocks/BlockAdvertorialBadge.vue'
import { useContentBlock } from '../../content-blocks/composables/use-content-block'

const props = defineProps<{ id: string }>()
const id = computed(() => props.id)
const contentBlock = useContentBlock(id.value, 'adDividingLine')

</script>

<template>
  <BlockContainer class="w-[320px] md:w-[900px]">
    <AdDivider :position="(contentBlock.data.adDividingLine.position as 'start' | 'end')">
      <template v-if="contentBlock.data.adDividingLine.position === 'start'"
                #badge>
        <BlockAdvertorialBadge />
      </template>
    </AdDivider>
  </BlockContainer>
</template>
